// extracted by mini-css-extract-plugin
export var rssCategories = "rss-parser-module--rss-categories--16a65";
export var rssContent = "rss-parser-module--rss-content--8bde3";
export var rssImage = "rss-parser-module--rss-image--05190";
export var rssTitle = "rss-parser-module--rss-title--af35a";